import { isMobile } from "react-device-detect";
import Translate from "@identitybuilding/idb-react-translations";

const punycode = require("punycode/");

let host = window.location.hostname;
host = host.replace("www.", ""); // No change if no "www."

// Filter out frontend and migration prefixes early
host = host
  .replace(/^frontend\./, "") // "migration.ondernemersnetwerk.be"
  .replace(/^migration\./, ""); // "ondernemersnetwerk.be"

let devMode = false;
const hostParts = host.split('.');
if (hostParts.includes('migration') || host.includes(".dev")) {
  devMode = true;
}

// Split the host into parts
let parts = host.match(/([a-z0-9|-]+)/g); // ["ondernemersnetwerk", "be"]

// Determine subdomain
let subdomain = "";
if (parts.length === 3 || parts.length === 4) {
  // If there's a subdomain before the main domain (not frontend/migration)
  subdomain = parts[0].toLowerCase(); // Would need a real subdomain in URL
}

// Decode subdomain with punycode
let decoded_subdomain = punycode.toUnicode(subdomain);
subdomain = decoded_subdomain;

// Determine domain
let domain = host
  .replace(/^www\./, "")
  .replace(/^frontend\./, "")
  .replace(/^migration\./, "")
  .replace(/\.frontend/g, "")
  .replace(/\.migration/g, "")
  .match(/([a-z0-9|-]+)/g);
domain =
  domain.length === 2 || domain.length === 1
    ? domain[0].toLowerCase() // "ondernemersnetwerk"
    : domain.length === 3
      ? domain[1].toLowerCase()
      : domain[2] && domain[2].toLowerCase();

      console.log({domain, subdomain, host, hhost: window.location.hostname})
// Language detection
let lang =
  host.includes("ondernemersnetwerk") || host.includes("100procentlokaal")
    ? "nl"
    : host.includes("reseauentrepreneurs") || host.includes("100pourcentlocale")
      ? "fr"
      : host.includes("entrepreneursnetwork")
        ? "en"
        : "nl";

// Translation slugs
const search_slug = Translate("search_slug", lang);
const page_slug = Translate("page", lang).toLowerCase();
const initialState = {
  lang: lang,
  translate: (x) => Translate(x, lang),
  device: isMobile ? "mobile" : "desktop",
  nis: subdomain,
  decoded_nis: decoded_subdomain,
  dev: devMode,
  domain: domain,
  search_path: (location, keyword, page, keyboard, as, filter) => {
    let loc = "";

    if (typeof location === "object") {
      if (location.length === 1) {
        if (location[0].slug === subdomain) {
          loc = false;
        } else {
          loc = location[0].slug;
        }
      } else {
        loc = location.map((loc) => loc.slug);
      }
    } else {
      loc = location;
    }
    return `/${search_slug}${loc ? `/${loc}` : ""}${keyword ? `/${keyword}` : ""
      }${page ? `/${page_slug}=${page}` : ""}${as ? `?category=${as}` : ""}${filter && filter.length > 0 ? `${as ? "&" : "?"}service=${filter}` : ""
      }`;
  },
};

const GeneralReducer = (state = initialState, action) => state;

export default GeneralReducer;
